module.exports = __webpack_public_path__ + "img/dyimg.8f4606b8.jpg";